import type {
  PreferencesXinglet,
  PreferencesProps,
} from '@xing-com/crate-lebenslauf-xinglets';

import { Preferences as PreferencesComponent } from './preferences';

export default class Preferences implements PreferencesXinglet {
  public getComponent(): React.ComponentType<PreferencesProps> {
    return (props) => <PreferencesComponent {...props} />;
  }
}
